module.exports = __webpack_public_path__ + "static/media/customization.d619a808.svg";